@if (data) {
  <ng-container *ngFor="let section of data">
    @if (section['__component'] == 'components.video-intro-block') {
      <app-video-intro-block [data]="section"></app-video-intro-block>
    }
    @else if (section['__component'] == 'components.call-to-action-with-countdown') {
      <app-call-to-action-with-countdown [data]="section"></app-call-to-action-with-countdown>
    }
    @else if (section['__component'] == 'components.article') {
      <app-article [data]="section"></app-article>
    }
     @else if (section['__component'] == 'components.sponsor-banner') {
      <app-sponsor-banner [data]="section"></app-sponsor-banner>
    }
    @else if (section['__component'] == 'components.article-list') {
      <app-article-list [data]="section"></app-article-list>
    }
    @else if (section['__component'] == 'components.article-with-collapsible-panels') {
      <app-article-with-collapsible-panels [data]="section"></app-article-with-collapsible-panels>
    }
     @else if (section['__component'] == 'components.event-list') {
      <app-event-list [data]="section"></app-event-list>
    }
     @else if (section['__component'] == 'components.pdf-download-list') {
      <app-pdf-download-list [data]="section"></app-pdf-download-list>
    }
    @else if (section['__component'] == 'components.contact-form') {
      <app-contact-form [data]="section"></app-contact-form>
    }
  </ng-container>
}